import { Pagination } from '../paginations/pagination.model';

export enum TodoStateFilterEnum {
  All = 1,
  Incomplete = 2,
  Pending = 3,
  Overdues = 4
}

export interface TodoRequestFilter extends Pagination {
  search?: string;
  state?: TodoStateFilterEnum | null;
  clientId?: number;
  caseId?: number;
  isCompleted?: boolean;
}
